module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case"
  }, [_c('header', [_vm._m(0), _vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "casebox"
  }, [_c('div', {
    staticClass: "casetop"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.medical_list.date_info[0]))]), _c('em', [_vm._v(_vm._s(_vm.medical_list.date_info[1]))]), _c('span', {
    staticClass: "hour"
  }, [_vm._v(_vm._s(_vm.medical_list.date_info[2]))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "person"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.medical_list.patient_name))]), _c('span', {
    staticClass: "sex"
  }, [_vm._v(_vm._s(_vm.medical_list.patient_sex))]), _c('span', {
    staticClass: "age"
  }, [(_vm.medical_list.patient_age) ? _c('span', [_vm._v(_vm._s(_vm.medical_list.patient_age ? _vm.medical_list.patient_age + '岁' : ''))]) : _vm._e()]), (_vm.medical_list.total_price && _vm.offActive) ? _c('span', {
    staticClass: "fee"
  }, [_vm._v("¥" + _vm._s(_vm.medical_list.total_price))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hospital"
  }, [_c('span', {
    staticClass: "hospitalname"
  }, [_vm._v(_vm._s(_vm.medical_list.hospital))]), _c('span', {
    staticClass: "department"
  }, [_vm._v(_vm._s(_vm.medical_list.department))])]), _vm._v(" "), _c('div', {
    staticClass: "doctor"
  }, [_c('span', [_vm._v("主治医生：")]), _c('em', [_vm._v(_vm._s(_vm.medical_list.doctor_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "casecenter"
  }, [_c('div', {
    staticClass: "ui-navigator",
    attrs: {
      "id": "J_NavList"
    }
  }, [_c('div', {
    staticClass: "ui-scroller"
  }, [_c('ul', {
    staticClass: "ui-navigator-list"
  }, [_c('li', {
    class: {
      'ui-state-active': _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.isActive = true;
        _vm.offActive = false;
      }
    }
  }, [_c('span', [_vm._v("电子病历")])]), _vm._v(" "), _c('li', {
    class: {
      'ui-state-active': _vm.offActive
    },
    on: {
      "click": function($event) {
        _vm.offActive = true;
        _vm.isActive = false;
      }
    }
  }, [_c('span', [_vm._v("治疗明细")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "items-detail"
  }, [(_vm.isActive) ? _c('div', {
    staticClass: "J_ItemDetail"
  }, [_c('div', {
    staticClass: "tit-con-box"
  }, [_c('h4', {
    staticClass: "tit-box"
  }, [_vm._v("主诉：")]), _vm._v(" "), _c('div', {
    staticClass: "con-box"
  }, [_c('div', {
    staticClass: "textbox"
  }, [_vm._v(_vm._s(_vm.reception.chiefComplaint))])])]), _vm._v(" "), _c('div', {
    staticClass: "tit-con-box"
  }, [_c('h4', {
    staticClass: "tit-box"
  }, [_vm._v("现病史：")]), _vm._v(" "), _c('div', {
    staticClass: "con-box"
  }, [_c('div', {
    staticClass: "textbox"
  }, [_vm._v(_vm._s(_vm.reception.historyOfPresentIllness))])])]), _vm._v(" "), _c('div', {
    staticClass: "tit-con-box"
  }, [_c('h4', {
    staticClass: "tit-box"
  }, [_vm._v("既往史：")]), _vm._v(" "), _c('div', {
    staticClass: "con-box"
  }, [_c('div', {
    staticClass: "nocon"
  }, [_vm._v(_vm._s(_vm.reception.pastHistory))])])]), _vm._v(" "), _c('div', {
    staticClass: "tit-con-box"
  }, [_c('h4', {
    staticClass: "tit-box"
  }, [_vm._v("检查：")]), _vm._v(" "), _vm._l((_vm.checkList), function(item) {
    return _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "textbox"
    }, [_vm._v(_vm._s(item.remark))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tit-con-box"
  }, [_c('h4', {
    staticClass: "tit-box"
  }, [_vm._v("诊断：")]), _vm._v(" "), _vm._l((_vm.diagnosisList), function(item) {
    return _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "tenimg"
    }, [_c('div', {
      staticClass: "img_center ten-img-center",
      attrs: {
        "id": "J_Toothtwo"
      }
    }, [_c('span', {
      staticClass: "horizontal-line"
    }), _vm._v(" "), _c('span', {
      staticClass: "vertical-line"
    }), _vm._v(" "), _c('span', {
      staticClass: "select-area top-left J_SelectArea0"
    }, [_vm._v(_vm._s(item.upperLeftTooth))]), _vm._v(" "), _c('span', {
      staticClass: "select-area top-right J_SelectArea1"
    }, [_vm._v(_vm._s(item.upperRightTooth))]), _vm._v(" "), _c('span', {
      staticClass: "select-area bottom-left J_SelectArea2"
    }, [_vm._v(_vm._s(item.lowerLeftTooth))]), _vm._v(" "), _c('span', {
      staticClass: "select-area bottom-right J_SelectArea3"
    }, [_vm._v(_vm._s(item.lowerRightTooth))])])]), _vm._v(" "), _c('div', {
      staticClass: "textbox"
    }, [_vm._v(_vm._s(item.remark))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tit-con-box"
  }, [_c('h4', {
    staticClass: "tit-box"
  }, [_vm._v("治疗计划：")]), _vm._v(" "), _vm._l((_vm.planList), function(item) {
    return _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "textbox"
    }, [_vm._v(_vm._s(item.remark))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tit-con-box"
  }, [_c('h4', {
    staticClass: "tit-box"
  }, [_vm._v("处理：")]), _vm._v(" "), _vm._l((_vm.treatmentList), function(item) {
    return _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "textbox"
    }, [_vm._v(_vm._s(item.remark))])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.offActive) ? _c('div', {
    staticClass: "J_ItemDetail"
  }, [_vm._l((_vm.treatmentCharges), function(item) {
    return _c('div', {
      staticClass: "tit-con-box"
    }, [_c('h4', {
      staticClass: "tit-box"
    }, [_vm._v("诊疗单：")]), _vm._v(" "), _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "small-tit-con"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("单号：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.billNo))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("缴费状态：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.chargeStatus == 1 ? '已缴费' : '未缴费'))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("品名：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.itemName))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("单位：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.itemUnitName))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("数量：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.itemNum))])])])])
  }), _vm._v(" "), _vm._l((_vm.recipeCharges), function(item) {
    return _c('div', {
      staticClass: "tit-con-box"
    }, [_c('h4', {
      staticClass: "tit-box"
    }, [_vm._v("处方单：")]), _vm._v(" "), _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "small-tit-con"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("单号：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.billNo))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("缴费状态：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.chargeStatus == 1 ? '已缴费' : '未缴费'))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("品名：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.itemName))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("单位：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.itemUnitName))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("用量：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.medicineDosage))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("用药频率：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.childRecipe.medicineFrequency))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("用法：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.childRecipe.medicineUsage))])])])])
  }), _vm._v(" "), _vm._l((_vm.radiateCharges), function(item) {
    return _c('div', {
      staticClass: "tit-con-box"
    }, [_c('h4', {
      staticClass: "tit-box"
    }, [_vm._v("放射单：")]), _vm._v(" "), _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "small-tit-con"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("单号：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.billNo))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("缴费状态：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.chargeChild.chargeStatus == 1 ? '已缴费' : '未缴费'))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("拍片类型：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.radiate.radiographicContent))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con boders"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("牙片张数：")]), _vm._v(" "), _c('span', {
      staticClass: "small-con"
    }, [_vm._v(_vm._s(item.radiate.radiographicNum))])]), _vm._v(" "), _c('div', {
      staticClass: "small-tit-con"
    }, [_c('span', {
      staticClass: "small-tit"
    }, [_vm._v("拍摄牙位：")]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "teeth_img"
    }, [_c('img', {
      staticClass: "all",
      attrs: {
        "src": "/static/img/teeth/all.png"
      }
    }), _vm._v(" "), _vm._l((_vm.handleImg(item.radiate.positinTooth)), function(itemUrl) {
      return _c('div', [(itemUrl) ? _c('div', [_c('img', {
        class: 'tooth' + itemUrl,
        attrs: {
          "src": _vm.baseUrl + itemUrl + ".png"
        }
      })]) : _vm._e()])
    })], 2)])])])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  })]), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "back",
    attrs: {
      "href": "/#/record"
    }
  }, [_c('div', {
    staticClass: "arrow-left"
  }, [_c('div', {
    staticClass: "arrow"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-04e900de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Case.vue
// module id = 187
// module chunks = 1